import { routeCreator as campaignRouteCreator } from '@occc-app/routes/Campaign/utils';

export const getBreadcrumbs = (params: {
  campaignId: string;
  campaignName: string;
  campaignComponentId: string;
  campaignComponentName: string;
}) => [
  {
    to: campaignRouteCreator.list(),
    label: 'Campaigns',
  },
  {
    to: campaignRouteCreator.details(params.campaignId),
    label: params.campaignName,
  },
  {
    to: `/campaigns/${params.campaignId}/${params.campaignComponentId}`,
    label: params.campaignComponentName,
  },
  { label: 'Code Details', key: 'Code Details' },
];
